import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Heart, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import contentData from '../data/content.json';

const DonorTestimonials = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const testimonials = contentData.donorTestimonials;

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    const timer = setInterval(nextSlide, 7000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative max-w-6xl mx-auto">
      <div className="overflow-hidden">
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="min-w-full px-2">
              <Card className="border-none shadow-2xl bg-white">
                <CardContent className="p-8 md:p-12">
                  <div className="flex items-center justify-center mb-8">
                    <Quote className="w-12 h-12 text-warm-amber opacity-50" />
                  </div>
                  
                  <div className="text-center">
                    <div className="flex items-center justify-center mb-6">
                      <Heart className="w-10 h-10 text-warm-amber" fill="currentColor" />
                    </div>
                    <h3 className="text-2xl font-bold font-heading text-forest-green mb-2">
                      {testimonial.name}
                    </h3>
                    <p className="text-warm-amber font-semibold mb-4">{testimonial.title}</p>
                    <p className="text-sm text-gray-500 mb-8">{testimonial.month}</p>
                    <p className="text-gray-700 text-lg leading-relaxed italic max-w-3xl mx-auto">
                      "{testimonial.text}"
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Buttons */}
      <Button
        onClick={prevSlide}
        className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white hover:bg-warm-amber text-forest-green hover:text-white rounded-full p-2 shadow-lg transition-all z-10"
        size="icon"
      >
        <ChevronLeft className="w-6 h-6" />
      </Button>
      
      <Button
        onClick={nextSlide}
        className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white hover:bg-warm-amber text-forest-green hover:text-white rounded-full p-2 shadow-lg transition-all z-10"
        size="icon"
      >
        <ChevronRight className="w-6 h-6" />
      </Button>

      {/* Dots Indicator */}
      <div className="flex justify-center gap-2 mt-6">
        {testimonials.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all ${
              index === currentSlide
                ? 'bg-warm-amber w-8'
                : 'bg-gray-300 hover:bg-gray-400'
            }`}
            aria-label={`Go to testimonial ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default DonorTestimonials;
